var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{attrs:{"placeholder":"请选择客户分组","disabled":_vm.disabled,"collapse-tags":_vm.collapse,"options":_vm.groupList,"clearable":"","props":_vm.treeProps},model:{value:(_vm.groupId),callback:function ($$v) {_vm.groupId=$$v},expression:"groupId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }